<script setup lang="ts">
import HashGlobeView from "@/views/HashGlobeView.vue";
import "./lib/data/codecs";
</script>

<template>
  <HashGlobeView />
</template>

<style lang="scss">
@use "@/assets/base.scss";
</style>
